import { DealStatusEnum } from 'api/generated';
export const DealStatusTranslate = {
  [DealStatusEnum.AwaitingPayment]: 'Ожидается оплата',
  [DealStatusEnum.Cancelled]: 'Отменено',
  [DealStatusEnum.Completed]: 'Выполнено',
  [DealStatusEnum.Dispute]: 'В процессе спора',
  [DealStatusEnum.InProgress]: 'В процессе',
  [DealStatusEnum.ReadyForPayment]: 'Готово к оплате',
  [DealStatusEnum.SubmittedForReview]: 'Готов к проверке',
} as const;

export enum ExecutionRequestStatus {
  pending = 'pending',
  accepted = 'accepted',
  rejected = 'rejected',
}

export const DisputeStatusTranslate = {
  [ExecutionRequestStatus.pending]: 'В ожидании',
  [ExecutionRequestStatus.accepted]: 'Принято к рассмотрению',
  [ExecutionRequestStatus.rejected]: 'Отклонено',
} as const;

export type DealStatusTranslate = typeof DealStatusTranslate[keyof typeof DealStatusTranslate];
export type DisputeStatusTranslate = typeof DisputeStatusTranslate[keyof typeof DisputeStatusTranslate];
